/*
 * spurtcommerce
 * version 4.3
 * http://www.spurtcommerce.com
 *
 * Copyright (c) 2020 piccosoft ltd
 * Author piccosoft ltd <support@piccosoft.com>
 * Licensed under the MIT license.
 */
import { Component, OnInit } from '@angular/core';
import { ListsSandbox } from '../../../../core/lists/lists.sandbox';
import { ListsService } from 'src/core/lists/lists.service';
import { environment } from '../../../../environments/environment';
import { ProductFilterComponent } from '../../../pages/products/product-filter/product-filter.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { emailValidator, matchingPasswords } from '../../../theme/utils/app-validators';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public registerForm: FormGroup;
  public submitted = false;

  name = environment.storename;
  Brands: any = [];
  Category: any = [];
  Information: any = [];
  settings: any = {};
  Footers: any;
  address: any;
  bbb: boolean;
  secure: boolean;
  trust: boolean;
  constructor(
    public formBuilder: FormBuilder,
    public listSandbox: ListsSandbox,
    private Api: ListsService,
    private filter: ProductFilterComponent,
    private router: Router,
  ) { }
  // initially calls listSandbox getPageList
  ngOnInit() {
    this.name = environment.storename;
    this.Footer(this.name);
    const params: any = {};
    params.limit = '';
    params.offset = 0;
    params.keyword = '';
    this.getsettings();
    this.registerForm = this.formBuilder.group({
      'mail_id': ['', Validators.compose([Validators.required, emailValidator])],
      'SettingsId': [environment.settingsId],
      'StoreName': [environment.storename]
    });
  }

  // dowload link for mobile app
  downloadApp() {
    window.open('https://play.google.com/store/apps/details?id=com.piccosoft.spurtcommerce');
  }
  openLink(link) {
    window.open(link);
    localStorage.setItem('specialdeal','0')
  }

  // Get Footer data by using Name
  Footer(id: any) {
    const data = {
      storename: id
    };
    this.Api.getFooterList(data).subscribe((res: any) => {
      // console.log('Footer-->', res.data)
      this.Footers = res.data;
      console.log("footer",this.Footers)
      if(this.Footers.bbbLogo == 1){
        this.bbb = true
      }
      else{
        this.bbb= false
      }

      if(this.Footers.secureLogo == 1){
        this.secure = true
      }
      else{
        this.secure = false
      }


      if(this.Footers.trustedWave == 1){
        this.trust = true
      }
      else{
        this.trust= false
      }
      this.modifiedAddress(this.Footers?.address)
      for (let i = 0; i < 7; i++) {
        this.Brands.push(res.data.brand[i]);
      }
      // this.Brands = res.data.brand
      this.Category = res.data.category;
      this.Information = res.data.informationPage;
      console.log('---------info',this.Information)
    });
  }
  modifiedAddress(address){
   this.address = address.replace('Avenue, ', 'Avenue,<br>')
  } 
  getsettings() {
    this.Api.getsettings()
      .subscribe((res: any) => {
        console.log('settings-->', res.data);
        this.settings = res.data[0];
      });
  }
  // go to products
  gotofilter(i) {
    console.log('iiiii=>', i);
    // this.filter.selectBrand(s,i)
    this.router.navigate(['/products'], { queryParams: { 'brand': i } });
  }


  Subscribe() {
    this.submitted = true;
    if (this.registerForm.invalid)
      return
    console.log('this.register.value--->', this.registerForm.value);
    this.Api.Subscribe(this.registerForm.value)
      .subscribe((res:any)=>{
        console.log('this.register.value--->', res);
        this.submitted = false;
        this.registerForm.reset();
      })
  }
  redirect(){
    this.router.navigate(['//src/default/pages/foot-review']); 
  }
  importLocal(){
    localStorage.setItem('specialdeal','0')
  }
}
